import React, { useRef, useEffect, useState } from "react";
import { Card } from "reactstrap";
import { useHistory } from "react-router-dom";
import { ReactComponent as BackArrow } from "../../../../../../../assets/img/svg/BackArrow.svg";
import ListComponent from "./ListComponent";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import {
  purchaseTypes,
  getDropdowns,
  createReqObj,
  sapendpoint,
  actionType
} from "./constants";
import styles from "./styles.module.scss";

import {
  fetchAllPostPromisedData,
  generateRandomId,
} from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { successToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { saveOrDeleteMsg } from "../sapProfitCostCentreMapping/constant";
import MessageDialog from "./MessageDialog";
import Header from "./Header";
import ALoader from "views/pages/manage/common/a-loader";
import CustomUpload from "./CustomUpload";

const SapPurchaseOrder = () => {
  const history = useHistory();
  const ref = useRef();
  const [isLoading, setLoading] = useState(false);

  const [paginationInfo, setPaginationInfo] = useState({
    currentPage: 0,
    totalRecords: 0,
  });

  const [purchaseType, setPurchaseType] = useState(null);
  const [purchaseOrder, setPurchaseOrder] = useState({
    capexPr: [],
    opexPr: [],
    servicePr: [],
    normalPr: []
  });
  const [dropdownData, setDropdownData] = useState([]);
  const [headerData, setHeaderData] = useState([]);
  const [errorResponse, setErrorResponse] = useState(null);
  const [fileData, setFileData] = useState({});

  const pageChangeHandler = (newPage) => { };
  const init = async () => {
    try {
      setLoading(true);
      const dropdown = await getDropdowns();
      setDropdownData(dropdown);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handlePurchaseTypeChange = (newPurchaseType) => {
    if (ref?.current?.isTableInEditMode) {
      failureToast(saveOrDeleteMsg);
      return;
    }
    setPurchaseType(newPurchaseType);
    setHeaderData((prev) => ({ ...prev, Doc_Type: "" }));
  };

  const updatePurchaseOrder = (updatedRows) => {
    setPurchaseOrder((prev) => ({
      ...prev,
      [purchaseType?.value]: updatedRows,
    }));
  };

  const createUpdateHandler = (rowForm) => {
    try {
      const isItemNoUnique = !purchaseOrder[purchaseType?.value]?.some(
        (row) => row.Item_no === rowForm.Item_no
      );

      if (isItemNoUnique && rowForm?.isNew) {
        // Add new row based on purchaseType
        setPurchaseOrder((prev) => ({
          ...prev,
          [purchaseType?.value]: [
            ...prev[purchaseType?.value],
            { ...rowForm, isNew: false },
          ],
        }));
      } else {
        // Update existing row in the correct purchaseType array
        const updatedRows = [...purchaseOrder[purchaseType?.value]];
        updatedRows[rowForm?.Item_no - 1] = { ...rowForm, isNew: false };
        updatePurchaseOrder(updatedRows);
      }
      ref.current.stopEditing();
    } catch (e) {
      console.error("Error in createUpdateHandler: ", e);
    }
  };

  const saveAllPrHandler = async () => {
    try {
      setLoading(true);
      let url = sapendpoint?.create;
      let method = "post";
      let reqObj = createReqObj(
        headerData,
        purchaseOrder[purchaseType?.value],
        purchaseType?.value,
        actionType[0],
        null,
        fileData
      );
      const resp = await fetchAllPostPromisedData(url, reqObj, method);

      if (resp?.code == 200) {
        if (resp?.data?.mt_pr_res?.isError == "false") {
          setFileData({});
          setPurchaseOrder({
            capexPr: [],
            opexPr: [],
            servicePr: [],
            normalPr: []
          });
          setHeaderData([]);
        }
        const returnData = resp?.data?.mt_pr_res?.Return;
        if (returnData?.length) {
          setErrorResponse((prev) => (
            {
              ...prev,
              isCopy: resp?.data?.mt_pr_res?.PR_no ? true : false,
              PR_no: resp?.data?.mt_pr_res?.PR_no,
              list: returnData?.map((error, index) => ({
                id: generateRandomId() + index,
                ...error,
              }))
            }
          ))
        }
        console.log("error res", errorResponse);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <Card className="mx-2">
        <div className="d-flex my-3 mx-2 gap-lg">
          <div className="d-flex justify-content-between">
            <BackArrow
              className="color-black mr-2 cursor"
              onClick={() => history.goBack()}
            />
            <h4 className="color-black ml-2 mb-0">SAP Purchase Requisition</h4>
          </div>
          <div style={{ padding: "0 10px", width: "25%" }}>
            <AAutoComplete
              currentValue={purchaseType}
              handleChange={(value) => {
                handlePurchaseTypeChange(value);
              }}
              items={purchaseTypes}
              isMulti={false}
              placeholder={"Please Select Type"}
            />
          </div>
        </div>

        {purchaseType && (
          <div className="d-flex my-3" style={{ padding: "0 10px" }}>
            <Header headerData={headerData} setHeaderData={setHeaderData} purchaseType={purchaseType} />
            <AButton
              variant="primary_filled"
              onClick={() => ref.current.addNewRow()}
              size="xs"
            >
              Add new
            </AButton>
          </div>
        )}
        {isLoading && <ALoader position='fixed' />}
        <ListComponent
          rows={purchaseOrder[purchaseType?.value] || []}
          ref={ref}
          loading={isLoading}
          setLoading={setLoading}
          currentPage={paginationInfo.currentPage}
          totalRecords={paginationInfo.totalRecords}
          pageChangeHandler={pageChangeHandler}
          createUpdateHandler={createUpdateHandler}
          dropdownData={dropdownData}
          purchaseReqType={purchaseType?.value}
          updatePurchaseOrder={updatePurchaseOrder}
          headerData={headerData}
        />

        {purchaseType && (
          <>
            <div className={`${styles["upload-btn-style"]}`}>
              <CustomUpload
                fileData={fileData}
                setFileData={setFileData}
                id={"sap-file"}
              />
            </div>

            <div className="d-flex justify-content-start mt-2">
              <AButton
                variant="primary_filled"
                onClick={saveAllPrHandler}
                size="xs"
                disabled={
                  !headerData?.Text ||
                  !headerData?.Doc_Type ||
                  purchaseOrder[purchaseType?.value]?.length === 0
                }
              >
                Save
              </AButton>
            </div>
          </>
        )}

        {errorResponse && !isLoading && (
          <MessageDialog
            rows={errorResponse?.list}
            prNo={errorResponse?.PR_no}
            setErrorResponse={setErrorResponse}
            loading={isLoading}
            msgLabelKey={"Message_text"}
            errorKey={"Message_code"}
            showClipboard={errorResponse?.isCopy}
          />
        )}
      </Card>
    </>
  );
};

export default SapPurchaseOrder;
